import React from 'react';
import '@assets/sass/components/preloader.scss';

export default ({visible}) => visible ?
    <div>
        <div className="preloader-conical"/>
        <div className="preloader-fade"/>
    </div> : ''
